import { Component, Inject, OnInit, HostListener, ElementRef, Renderer2, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { FileService } from 'app/services/file.service';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { DrakeFilePreviewComponent } from '../drake-file-preview/drake-file-preview.component';
import { GridModule, PageChangeEvent } from '@progress/kendo-angular-grid';
import { MenusModule, MenuItem } from "@progress/kendo-angular-menu";
import { MatDialogModule } from '@angular/material/dialog';
import { FilePreviewDialogComponent } from '../file-preview-dialog/file-preview-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { NewFolderDialogComponent } from '../new-folder-dialog/new-folder-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NotificationsService } from 'angular2-notifications';
import { NotificationsConfigModule } from '../../notification/notification.module';
import { ConfirmCancelDialogComponent } from '../drake-confirm-cancel-dialog/drake-confirm-cancel-dialog.component';
import { GridService } from 'app/services/grid.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';
import { ProgressDialogService } from 'app/services/progress-dialog.service';
import { ShareLevelDialogComponent } from './share-level-dialog/share-level-dialog.component';
import { ShareLevelDialogComponentFile } from './share-level-dialog-file/share-level-dialog.component-file';
import { ShareLevelPropertiesDialogComponent } from './share-level-properties-dialog/share-level-properties-dialog.component';
import { State } from '@progress/kendo-data-query';
import { throwDialogContentAlreadyAttachedError } from '@angular/cdk/dialog';


@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.scss'],
  standalone: true,
  providers: [TranslocoPipe],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    HttpClientModule,
    TreeViewModule,
    GridModule,
    MenusModule,
    MatDialogModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    DrakeFilePreviewComponent,
    NotificationsConfigModule,
    TranslocoPipe
  ]
})
export class FileManagerComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @Input() fileCtrlFormat: string;

  public isMovingFile = false;
  public folders: any[] = [];
  public files: any[] = [];
  public selectedFile: any = null;
  public shareLevelOptions = [{ value: 'PRV', text: 'PRIVATA' }, { value: 'DOM', text: 'DOMINIO' }, { value: 'PUB', text: 'PUBBLICA' }];
  public shareLevelEditOptions = [{ value: 'PRV', text: 'PRIVATA' }, { value: 'DOM', text: 'DOMINIO' }, { value: 'PUB', text: 'PUBBLICA' }];
  folderShareLevel: string = '';
  folderShareLevelEdit: string = '';
  public selectedFolder: any = null;
  public rootId = 'ROOT';
  public selectedFiles: Array<any> = [];
  public contextMenuItems: MenuItem[] = [
    { text: this.translocoPipe.transform('modal.folder.rename'), data: 'rinomina' },
    { text: this.translocoPipe.transform('modal.folder.delete'), data: 'elimina' }
  ];
  public contextMenuVisible = false;
  contextMenuPosition = { x: '0px', y: '0px' };
  public isDragging = false;
  showFolderShareLevelSelect: boolean = false;

  public folderShareLevelSelected: string = '';
  public folderShareLevelEditSelected: string = '';

  private selectedShareLevel:any = null;
  
  private lastPath:string[] = ["ROOT"];
  public selectedKeys = ["0_0"];
  private expandedKeys:string[] = [];    
  
  public skip:number = 0;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FileManagerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fileService: FileService,
    public sanitizer: DomSanitizer,  // Inietta DomSanitizer
    private notifications: NotificationsService,
    private el: ElementRef,
    private renderer: Renderer2,
    private gridService: GridService,
    private translocoPipe: TranslocoPipe,
    private progressDialogService: ProgressDialogService

  ) {
    this.renderer.listen('window', 'dragover', (event) => {
      event.preventDefault();
    });
    this.renderer.listen('window', 'drop', (event) => {
      event.preventDefault();
    });
  }

  ngOnInit(): void {
    this.showFolderShareLevelSelect = false; // Nascondi la select all'avvio

    this.loadFolders(this.rootId);
    //PER TEST USO 'FILE', togliere il comento a this.fileCtrlFormat = this.data.fileCtrlFormat || 'FILE'; per ufficiale
    this.fileCtrlFormat = 'FILE';
    //this.fileCtrlFormat = this.data.fileCtrlFormat || 'FILE'; 
    setTimeout(() => {
      this.expandRootNode();
      this.selectedFolder = { id: this.rootId }; // Seleziona la root all'inizio
    }, 0);
  }

  expandRootNode(): void {
    const rootNode = document.querySelector('.k-item.k-first');
    if (rootNode) {
      const toggleButton = rootNode.querySelector('.k-icon.k-i-expand') as HTMLElement;
      if (toggleButton) {
        toggleButton.click();
      }
    }
  }

  getAcceptedFileTypes(): string {
    switch (this.fileCtrlFormat) {
      case 'IMAGE':
        return '.jpg,.jpeg,.png,.gif,.bmp,.svg';
      case 'DOC':
        return '.docm,.docx,.dot,.pdf,.xls,.xlsx,.ppt,.pptx';
      case 'VIDEO':
        return '.mp4,.avi,.wmv';
      case 'AUDIO':
        return '.mp3,.wav,.flac';
      case 'TEXT':
        return '.txt';
      default:
        return '';
    }
  }

  openExternalUploadDialog(): void {
    if (this.isRootSelected()) {
      var notification = this.translocoPipe.transform("notification.error.file.uploadRoot");
      this.showErrorNotification(notification);
      return;
    } else {

      const dialogRef = this.dialog.open(NewFolderDialogComponent, {
        width: '400px',
        data: { fileName: '', fileUrl: '', provider: '', fileType: '', action: 'externalUpload' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.action === 'externalUpload') {
          this.uploadExternalFile(result.fileName, result.fileUrl, result.provider, result.fileType);
        }
      });
    }
  }

  updateShareLevel(): void {
    if (this.selectedFile) {
      const fileId = this.selectedFile.id;
      const newShareLevel = this.selectedFile.shareLevel;
      const isExternal = this.selectedFile.isExternal;

      this.fileService.updateShareLevel(fileId, newShareLevel, isExternal).subscribe(
        (response: any) => {
          console.log('Share level updated successfully:', response);
        },
        (error: any) => {
          console.error('Error updating share level:', error);
        }
      );
    }
  }

  updateShareLevelEdit(): void {
    if (this.selectedFile) {
      const fileId = this.selectedFile.id;
      const newShareLevel = this.selectedFile.shareLevelEdit;
      const isExternal = this.selectedFile.isExternal;

      this.fileService.updateShareLevel(fileId, newShareLevel, isExternal, true).subscribe(
        (response: any) => {
          console.log('Share level updated successfully:', response);
        },
        (error: any) => {
          console.error('Error updating share level:', error);
        }
      );
    }
  }



  // Metodo per selezionare una cartella
  selectFolder(event: any): void {
    const selectedFolderId = event.selectedRows[0].dataItem.id;

    const selectedFolder = this.folders.find(folder => folder.id === selectedFolderId);
    if (selectedFolder) {
      this.selectedFolder = selectedFolder;
      this.folderShareLevel = selectedFolder.shareLevel || 'PRV'; // Imposta il valore di default
      this.folderShareLevelEdit = selectedFolder.shareLevelEdit || 'PRV'; // Imposta il valore di default
      this.showFolderShareLevelSelect = true; // Mostra la select
    }
  }

  updateFolderShareLevel(): void {
    if (this.selectedFolder) {
      const folderId = this.selectedFolder.id;

      const newShareLevel = this.selectedFolder.shareLevel;
      this.fileService.updateFolderShareLevel(folderId, newShareLevel).subscribe(
        (response: any) => {
          console.log('Folder share level updated successfully:', response);
        },
        (error: any) => {
          console.error('Error updating folder share level:', error);
        }
      );
    }
  }

  updateFolderShareLevelEdit(): void {
    if (this.selectedFolder) {
      const folderId = this.selectedFolder.id;

      const newShareLevel = this.selectedFolder.shareLevelEdit;
      this.fileService.updateFolderShareLevel(folderId, newShareLevel, true).subscribe(
        (response: any) => {
          console.log('Folder share level edit updated successfully:', response);
        },
        (error: any) => {
          console.error('Error updating folder share level:', error);
        }
      );
    }
  }

  uploadExternalFile(fileName: string, fileUrl: string, provider: string, fileType: string): void {

    const currentUserId = this.getCurrentUserId();

    const payload = {
      FileName: fileName,
      FileUrl: fileUrl,
      OwnerCode: currentUserId,
      FolderId: this.selectedFolder?.id || this.rootId,
      Provider: provider,
      FileType: fileType,
      ShareLevel: this.selectedFolder?.shareLevel || 'PRV',
      IsExternal: true,
      LastEditUserCode: currentUserId
    };

    this.gridService.saveScopeData("EXTERNALFILES", "UPSERT", payload, false).subscribe((result: any) => {
      console.log("EXTERNALFILES" + " - ", result)
      this.loadFiles(this.selectedFolder?.id ?? this.rootId);
    });
    /*
    this.fileService.uploadExternalFile(payload).subscribe(
        (response: any) => {
            if (response.message === "External file saved successfully.") {
                this.loadFiles(this.selectedFolder?.id ?? this.rootId);
                this.showSuccessNotification('File esterno caricato con successo');
            } else {
                this.showErrorNotification('Errore durante il caricamento del file esterno');
            }
        },
        (error) => {
            console.error('Upload external file error:', error);
            this.showErrorNotification('Errore durante il caricamento del file esterno');
        }
    );*/
  }





  isSelectedFileImage(): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    const fileExtension = this.selectedFile?.fileName?.split('.').pop().toLowerCase();
    return imageExtensions.includes(fileExtension);
  }



  // Verifica se la cartella selezionata è la root principale
  isRootSelected(): boolean {
    return this.selectedFolder?.id === this.rootId || !this.selectedFolder;
  }

  // Inizia il drag del file
  onDragStart(event: DragEvent, file: any): void {
    event.dataTransfer?.setData('text/plain', JSON.stringify(file));
    this.isDragging = true;
    this.isMovingFile = true; // Imposta isMovingFile su true quando si inizia a spostare un file

    // Evitare che l'overlay del drag and drop appaia durante lo spostamento dei file
    event.dataTransfer.effectAllowed = 'move';
  }

  onDragOverFolder(event: DragEvent, folder: any): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDropOnFolder(event: DragEvent, folder: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    this.isMovingFile = false; // Imposta isMovingFile su false quando il file viene rilasciato

    const fileData = event.dataTransfer?.getData('text/plain');
    if (fileData) {
      const file = JSON.parse(fileData);
      this.moveFileToFolder(file, folder);
    }
  }

  moveFileToFolder(file: any, folder: any): void {
    const payload = {
      fileId: file.id,
      newFileName: file.fileName,
      newFolderId: folder.id // Aggiungi l'ID della nuova cartella
    };

    this.fileService.updateFileName(payload.fileId, payload.newFileName, payload.newFolderId).subscribe(
      (response: any) => {
        console.log('Move file response:', response);
        if (response === true || response.success === true) {
          console.log('File moved successfully');
          this.loadFiles(this.selectedFolder?.id ?? this.rootId);
          var notification = this.translocoPipe.transform("notification.success.file.move");
          this.showSuccessNotification(notification + `${folder.folderName}`);
        } else {
          console.warn('Unexpected response structure:', response);
          var notification = this.translocoPipe.transform("notification.error.file.move");
          this.showErrorNotification(notification);
        }
      },
      (error) => {
        console.error('Move file error:', error);
        var notification = this.translocoPipe.transform("notification.error.file.move");
        this.showErrorNotification(notification);
      }
    );
  }

  // Drag and Drop Handlers
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.isDragging) {
      this.isDragging = true;
    }
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    // Verifica se l'elemento dragleave è effettivamente il container principale
    const rect = this.el.nativeElement.getBoundingClientRect();
    if (
      event.clientX < rect.left ||
      event.clientX >= rect.right ||
      event.clientY < rect.top ||
      event.clientY >= rect.bottom
    ) {
      this.isDragging = false;
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    if (this.isRootSelected()) {
      var notification = this.translocoPipe.transform("notification.error.file.uploadRoot");
      this.showErrorNotification(notification);
      return;
    }

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        this.uploadFile(files[i]);
      }
    }
  }

  uploadFile(file: File): void {
    


    const acceptedTypes = this.getAcceptedFileTypes().split(',');
    const fileExtension = '.' + file.name.split('.').pop();
    if (!acceptedTypes.includes(fileExtension) && this.fileCtrlFormat !== 'FILE') {
      var notification = this.translocoPipe.transform("notification.error.file.unsopportedFile");
      this.showErrorNotification(notification);
      return;
    }

    if (this.isRootSelected()) {
      var notification = this.translocoPipe.transform("notification.error.file.uploadRoot");
      this.showErrorNotification(notification);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const fileContentBase64 = e.target.result.split(',')[1];
      const formData = new FormData();
      formData.append('file', file);
      formData.append('fileName', file.name);
      formData.append('fileContentBase64', fileContentBase64);
      formData.append('folderId', this.selectedFolder?.id || this.rootId);
      formData.append('shareLevel', this.selectedFolder?.shareLevel || 'PRV');
      console.log('Uploading file to /drakeData/UploadFile', formData);
      this.fileService.uploadFile(formData).subscribe(
        (response: any) => {
          console.log('Upload response:', response);
          if (response.success) {
            this.loadFiles(this.selectedFolder?.id ?? this.rootId);
          } else {
            var notification = this.translocoPipe.transform("notification.error.file.upload");
            this.showErrorNotification(notification);
          }
        },
        (error) => {
          console.error('Upload error:', error);
          if (error.status === 409 && error.error.message === "File already exists") {
            this.showOverwriteDialog(file, fileContentBase64);
          } else {
            var notification = this.translocoPipe.transform("notification.error.file.upload");
            this.showErrorNotification(notification);
          }
        }
      );
    };
    reader.readAsDataURL(file);
  }

  loadFolders(parentId: string): void {
    this.fileService.getFoldersHierarchy().subscribe(
      (folders: any[]) => {

        this.folders = folders;

        let expandedState = localStorage.getItem('lastExpandedState');
        let lastSavedPath = localStorage.getItem('lastFolderPath');
        if (expandedState) {
          this.expandedKeys = JSON.parse(expandedState);

        }
        if (lastSavedPath){
          this.lastPath = JSON.parse(lastSavedPath);
          this.selectedKeys = this.buildSelection(this.lastPath);
        }
        console.log('Folders loaded', this.folders); // Log per il debug
      },
      (error) => {
        console.error('Error loading folders:', error);
      }
    );
  }
  public isExpanded = (dataItem: any, index: string) => {
    return this.expandedKeys.indexOf(index) > -1;
  }

  
  public handleCollapse(node) {
    this.expandedKeys = this.expandedKeys.filter((k) => k !== node.index);
    this.saveExpandedState();
  }

  public handleExpand(node) {
    this.expandedKeys = this.expandedKeys.concat(node.index);
    this.saveExpandedState();
  }
  private saveExpandedState(){
    localStorage.setItem('lastExpandedState', JSON.stringify(this.expandedKeys));
  } 

  public buildSelection(path:string[]) {
    let currentLevelFolders = this.folders;
    let keys = [];
    let item;
    for (let i = 0; i < path.length; i++){
      let j = currentLevelFolders.findIndex(f => f.id == path[i]);
      keys.push(j);
      item = currentLevelFolders[j];
      currentLevelFolders = item.children;
    }
    this.onSelectionChange({ dataItem: item });
    return [keys.join('_')];
  }

  public onPageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    console.log('skip', this.skip);
  }

  loadFiles(parentId: string): void {
    this.fileService.getFiles(parentId).subscribe(
      (files: any[]) => {
        this.files = files.map(file => {
          if (file.IsExternal) {
            file.isExternal = true;
            console.log("File esterno")
          }
          return file;
        });
        this.filterFilesByType();
        console.log('Files loaded', this.files);
        this.skip = 0;
      },
      (error) => {
        console.error('Error loading files:', error);
      }
    );
  }


  getFileStyle(file: any): any {
    if (file.isExternal) {
      console.log("StileExternal")

      return { 'background-color': 'rgba(255, 255, 0, 0.3)' };
    }
    return {};
  }

  openExternalFile(url: string): void {
    window.open(url, '_blank');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  selectFile(event: any): void {
    const selectedFileId = event.selectedRows[0].dataItem.id;
    const selectedFile = this.files.find(file => file.id === selectedFileId);
    if (selectedFile) {
      console.log("File: ", selectedFile);
      this.selectedFile = selectedFile;
      if (!selectedFile.isExternal) {
        this.loadFileContent(selectedFile);
      }
    }
  }


  loadFileContent(file: any): void {
    this.fileService.readFileAsBase64String(file.id).subscribe((response: any) => {
      const fileContentBase64 = response.fileContentBase64;
      const dataUrl = `data:${file.contentType};base64,${fileContentBase64}`;
      file.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
      this.selectedFile = file;

      // Force rendering PDF as a Blob object
      if (this.isPdfFile(file.fileName)) {
        const blob = this.base64ToBlob(fileContentBase64, file.contentType);
        file.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
      }
    }, (error) => {
      console.error('Error loading file content:', error);
    });
  }



  base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }




  openFilePreviewDialog(file: any): void {
    this.dialog.open(FilePreviewDialogComponent, {
      width: '80%',
      height: '80%',
      data: { fileId: file.id, fileType: file.contentType, fileName: file.fileName }
    });
  }





  getFileContentType(fileName: string): string {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'gif':
        return 'image/gif';
      case 'pdf':
        return 'application/pdf';
      default:
        return 'application/octet-stream';
    }
  }

  downloadFile(file: any): void {
    this.fileService.readFileAsBase64String(file.id).subscribe((response: any) => {
      const link = document.createElement('a');
      link.href = `data:${file.contentType};base64,${response.fileContentBase64}`;
      link.download = file.fileName;
      link.click();
    });
  }

  getCurrentUserId(): string {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.id || '';
  }

  isFileOwner(file: any): boolean {
    const currentUserId = this.getCurrentUserId();
    return file?.ownerCode === currentUserId;
  }

  isFileSystem(file: any): boolean {
    return file.isSystem === true;
  }

  isFolderOwner(folder: any): boolean {
    const currentUserId = this.getCurrentUserId();
    return folder?.ownerCode === currentUserId;
  }

  isFolderSystem(folder: any): boolean {
    //console.log("isSystem:", folder.isSystem)
    return folder.isSystem === true;
  }


  deleteFile(file: any): void {
    const dialogRef = this.dialog.open(ConfirmCancelDialogComponent, {
      width: '400px',
      data: {
        title: this.translocoPipe.transform('modal.file.title'),//'Conferma Eliminazione',
        message: this.translocoPipe.transform('modal.file.text'),//'Sei sicuro di voler eliminare il file',
        entityName: file.fileName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fileService.getFileUse(file.id).subscribe(

          (response: any) => {
            if (response.success || response.length == 0) {
              this.fileService.deleteFile(file.id).subscribe(
                (response: any) => {
                  if (response.success) {
                    this.files = this.files.filter(f => f.id !== file.id);
                    this.selectedFile = null;
                    console.log('File deleted', response);
                    this.loadFiles(this.selectedFolder?.id ?? this.rootId);
                  } else {
                    var notification = this.translocoPipe.transform("notification.error.file.delete");
                    this.showErrorNotification(notification);
                  }
                },
                (error) => {
                  console.error('Error deleting file:', error);
                  var notification = this.translocoPipe.transform("notification.error.file.delete");
                  this.showErrorNotification(notification);
                }
              );
            } else {
              var notification = this.translocoPipe.transform("notification.error.file.inUse");
              this.showErrorNotification(notification);

            }
          },
          (error) => {
            console.error('Error deleting file:', error);
            var notification = this.translocoPipe.transform("notification.error.file.delete");
            this.showErrorNotification(notification);
          }
        );


      }
    });
  }

  createFolder(): void {
    const currentUserId = this.getCurrentUserId();
    const domCode = JSON.parse(localStorage.getItem("user")).domCode;
    console.log("UserId", currentUserId);
    const dialogRef = this.dialog.open(NewFolderDialogComponent, {
      width: '400px',
      data: { folderName: '', errorMessage: '', action: 'create' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const newFolder = {
          _id: null,
          FolderName: result.folderName,
          OwnerCode: currentUserId,
          DomCode: domCode,
          ShareLevel: 'PRV',
          ParentFolderId: this.selectedFolder?.id ?? this.rootId,
          LastEditUserCode: currentUserId
        };
        this.fileService.createFolder(newFolder).subscribe(
          (response: any) => {
            console.log('Create folder response:', response); // Log the response for debugging
            const parsedResponse = JSON.parse(response.id); // Parse the JSON string
            if (parsedResponse.success) {
              this.loadFolders(this.selectedFolder?.id ?? this.rootId);
            } else {
              var notification = this.translocoPipe.transform("notification.error.folder.nameUsed");
              this.showErrorNotification(notification);
            }
          },
          (error) => {
            console.error('Create folder error:', error); // Log the error for debugging
            var notification = this.translocoPipe.transform("notification.error.folder.nameUsed");
            this.showErrorNotification(notification);
          }
        );
      }
    });
  }

  renameFolder(folder:any): void {
    if (folder) {
      const dialogRef = this.dialog.open(NewFolderDialogComponent, {
        width: '400px',
        data: { folderName: folder.folderName, errorMessage: '', action: 'rename' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const updatedFolder = {
            ...folder,
            FolderName: result.folderName,
            _id: folder._id || folder.id
          };
          this.fileService.updateFolder(updatedFolder).subscribe(
            (response: any) => {
              console.log('Rename folder response:', response); // Log the response for debugging
              //const parsedResponse = JSON.parse(response.id); // Parse the JSON string
              if (response.success) {
                this.loadFolders(folder.parentId ?? this.rootId);
                var notification = this.translocoPipe.transform("notification.success.folder.nameUsed");
                this.showSuccessNotification(notification);
              } else {
                var notification = this.translocoPipe.transform("notification.error.folder.nameUsed");
                this.showErrorNotification(notification);
              }
            },
            (error) => {
              console.error('Rename folder error:', error); // Log the error for debugging
              var notification = this.translocoPipe.transform("notification.error.folder.nameUsed");
              this.showErrorNotification(notification);
            }
          );
        }
      });
    }
  }

  showErrorNotification(message: string): void {
    this.notifications.error(this.translocoPipe.transform('notification.errorText'), message);
  }

  showWarnNotification(message: string): void {
    this.notifications.warn(this.translocoPipe.transform('notification.warnText'), message);
  }

  showSuccessNotification(message: string): void {
    this.notifications.success(this.translocoPipe.transform('notification.successText'), message);
  }

  triggerFileUpload(): void {
    if (this.isRootSelected()) {
      var notification = this.translocoPipe.transform("notification.error.file.uploadRoot");
      this.showErrorNotification(notification);
      return;
    }
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.accept = this.getAcceptedFileTypes();  // Imposta i tipi di file accettati
    fileUpload.click();
  }

  triggerFolderUpload(): void {
    const folderUpload = document.getElementById('folderUpload') as HTMLInputElement;
    //folderUpload.accept = this.getAcceptedFileTypes();  // Imposta i tipi di file accettati
    folderUpload.click();
  }
  async onFileSelected(event: any) {

    const file: File = event.target.files[0];

    const allowedExtensions = ['pdf', 'jpg', 'png', 'xlsx', 'docx', 'txt'];
    const fileExtensionCheck = file.name.split('.').pop()?.toLowerCase();

    if (!fileExtensionCheck || !allowedExtensions.includes(fileExtensionCheck)) {
      const notification = this.translocoPipe.transform("notification.error.unsupportedFileExtension");
      this.showErrorNotification(notification);
      return;
    }

    const shareLevel: any = await this.showShareLevelModalFile(file.name);
    if (!shareLevel) {
      const notification = this.translocoPipe.transform('notification.warn.folder.cancelledOperation');
      this.showWarnNotification(notification);
      throw new UploadCancelledError('User cancelled share level selection');
    }

    console.log("Share level:", shareLevel.shareLevel);
    console.log("Share level Edit:", shareLevel.shareLevelEdit);


    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const fileContentBase64 = e.target.result.split(',')[1];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileName', file.name);
        formData.append('fileContentBase64', fileContentBase64);
        formData.append('folderId', this.selectedFolder?.id || this.rootId);
        formData.append('shareLevel', shareLevel.shareLevel || this.selectedFolder?.shareLevel || 'PRV');
        formData.append('shareLevelEdit', shareLevel.shareLevelEdit || this.selectedFolder?.shareLevel || 'PRV');
        console.log('Uploading file to /drakeData/UploadFile', formData);
        this.fileService.uploadFile(formData).subscribe(
          (response: any) => {
            console.log('Upload response:', response);
            if (response.success) {
              this.loadFiles(this.selectedFolder?.id ?? this.rootId);
            } else {
              var notification = this.translocoPipe.transform("notification.error.folder.upload");
              this.showErrorNotification(notification);
            }
          },
          (error) => {
            console.error('Upload error:', error);
            if (error.status === 409 && error.error.message === "File already exists") {
              var fileEx:any = file;
              fileEx.id = error.error.fileId; 
              this.showOverwriteDialog(fileEx, fileContentBase64);
            } else {
              var notification = this.translocoPipe.transform("notification.error.file.upload");
              this.showErrorNotification(notification);
            }
          }
        );
      };
      reader.readAsDataURL(file);
    }
  }

  async onFolderSelected(event: any): Promise<void> {

    const shareLevel = await this.showShareLevelModal("", true, false);


    if (!shareLevel) {
      const notification = this.translocoPipe.transform('notification.warn.folder.cancelledOperation')
      this.showWarnNotification(notification);
      throw new UploadCancelledError('User cancelled share level selection');

    }

    const folder: FileList = event.target.files;
    if (!folder) return;

    const currentUserId = this.getCurrentUserId();
    const domCode = JSON.parse(localStorage.getItem("user")).domCode;
    const parentFolderId = this.selectedFolder?.id ?? this.rootId;

    const foldersMap = new Map<string, File[]>();
    Array.from(folder).forEach(file => {
      const pathArray = file.webkitRelativePath.split('/').slice(0, -1);
      const pathString = pathArray.join('/');
      if (!foldersMap.has(pathString)) {
        foldersMap.set(pathString, []);
      }
      foldersMap.get(pathString).push(file);
    });

    console.log('foldersMap', foldersMap);
    const pathStrings = Array.from(foldersMap.keys());
    pathStrings.sort((a, b) => a.split('/').length - b.split('/').length);

    const totalFiles = Array.from(foldersMap.values()).reduce((sum, files) => sum + files.length, 0);
    let uploadedCount = 0;

    this.progressDialogService.open(totalFiles);

    try {

      for (const pathString of pathStrings) {
        let finalFolderId = parentFolderId;

        if (pathString) {
          const pathArray = pathString.split('/');
          finalFolderId = await this.createFolderHierarchySequential(
            pathArray,
            parentFolderId,
            currentUserId,
            domCode
          );
        }

        const files = foldersMap.get(pathString) || [];
        for (const file of files) {
          
          try {

            const allowedExtensions = ['pdf', 'jpg', 'png' , 'txt'];
            const fileExtensionCheck = file.name.split('.').pop()?.toLowerCase();
        
            if (!fileExtensionCheck || !allowedExtensions.includes(fileExtensionCheck)) {
              const notification = this.translocoPipe.transform("notification.error.unsupportedFileExtension");
              this.showErrorNotification(notification);
              throw notification;
              return;
            }
          
            await this.uploadFileToFolderAsync(file, finalFolderId);
          } catch (uploadError) {
            console.error(`Errore nell'upload del file ${file.name}:`, uploadError);
          }
          uploadedCount++;
          this.progressDialogService.update(uploadedCount, file.name);
        }
      }

      this.progressDialogService.close();
      const notification = this.translocoPipe.transform("notification.success.folder.upload");
      this.showSuccessNotification(notification);
    } catch (error) {
      this.progressDialogService.close();
      if (error instanceof UploadCancelledError) {
        const notification = this.translocoPipe.transform('notification.warn.folder.cancelledOperation')
        this.showWarnNotification(notification);
      }
      else {
        console.error('Errore durante il caricamento dei file:', error);
        const notification = this.translocoPipe.transform("notification.error.folder.upload");
        this.showErrorNotification(notification);
      }
    }
    this.selectedShareLevel = null;
  }


  private async createFolderHierarchySequential(
    pathArray: string[],
    parentId: string,
    userId: string,
    domCode: string
  ): Promise<string> {
    let currentParentId = parentId;

    for (const folderName of pathArray) {
      currentParentId = await this.createOrGetFolder(folderName, currentParentId, userId, domCode);
    }

    return currentParentId;
  }

  private async createOrGetFolder(
    folderName: string,
    parentId: string,
    userId: string,
    domCode: string
  ): Promise<string> {
    const response: any = await firstValueFrom(
      this.fileService.getFolderByNameAndParent(folderName, parentId)
    );

    let existingFolderId: string = null;
    if (Array.isArray(response) && response.length > 0) {
      existingFolderId = response[0].folderId || response[0].Id;
    } else if (response && response.success && response.folderId) {
      existingFolderId = response.folderId;
    }

    if (existingFolderId) {
      console.log(`Cartella esistente: ${folderName} con ID: ${existingFolderId}`);
      return existingFolderId;

    }

    let shareLevel: any = null;
    shareLevel = this.selectedShareLevel;
    if (shareLevel == null)
      shareLevel = await this.showShareLevelModal(folderName, false, true);

    if (!shareLevel)
      throw new UploadCancelledError('User cancelled share level selection');

    if (shareLevel.keepSettings) { 
      this.selectedShareLevel = shareLevel;
    }

    const newFolder = {
      _id: null,
      FolderName: folderName,
      OwnerCode: userId,
      DomCode: domCode,
      ShareLevel: shareLevel.shareLevel,
      ShareLevelEdit: shareLevel.shareLevelEdit,
      ParentFolderId: parentId,
      LastEditUserCode: userId
    };

    try {
      const createResp = await firstValueFrom(this.fileService.createFolder(newFolder));
      let parsedCreate = typeof createResp.id === "string" ? JSON.parse(createResp.id) : createResp;
      if (typeof parsedCreate === 'string') {
        parsedCreate = JSON.parse(parsedCreate);
      }
      if (parsedCreate.success && parsedCreate.folderId) {
        console.log(`Cartella creata: ${folderName} con ID: ${parsedCreate.folderId}`);
        this.loadFolders(parsedCreate.folderId ?? this.rootId);
        this.folderShareLevelSelected = shareLevel.shareLevel;
        this.folderShareLevelEditSelected = shareLevel.shareLevelEdit;
        console.log("this.folderShareLevelSelected", this.folderShareLevelSelected);

        return parsedCreate.folderId;
      } else {
        throw new Error(`Impossibile creare la cartella ${folderName}, folderId non trovato`);
      }
    } catch (error: any) {
      if (error.status === 409) {
        console.log(`Conflitto: la cartella ${folderName} esiste già. Recupero l'ID...`);
        const retryResponse: any = await firstValueFrom(
          this.fileService.getFolderByNameAndParent(folderName, parentId)
        );
        let existingFolderIdRetry: string = null;
        if (Array.isArray(retryResponse) && retryResponse.length > 0) {
          existingFolderIdRetry = retryResponse[0].folderId || retryResponse[0].Id;
        } else if (retryResponse && retryResponse.success && retryResponse.folderId) {
          existingFolderIdRetry = retryResponse.folderId;
        }
        if (existingFolderIdRetry) {
          console.log(`Cartella già esistente (dopo conflitto): ${folderName} con ID: ${existingFolderIdRetry}`);
          return existingFolderIdRetry;
        }
      }
      throw error;
    }
  }


  private async uploadFileToFolderAsync(file: File, folderId: string): Promise<void> {

    const fileContentBase64 = await this.readFileAsBase64(file);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    formData.append('fileContentBase64', fileContentBase64);
    formData.append('folderId', folderId || this.rootId);
    formData.append('shareLevel', this.folderShareLevelSelected ? this.folderShareLevelSelected : 'PRV');
    formData.append('shareLevelEdit', this.folderShareLevelEditSelected ? this.folderShareLevelEditSelected : 'PRV');
    console.log("this.folderShareLevelSelected", this.folderShareLevelSelected);
    console.log('Uploading file:', file.name, 'to folder ID:', folderId);

    const response = await firstValueFrom(this.fileService.uploadFile(formData, true));
    if (response.success) {
      this.loadFiles(folderId ?? this.rootId);
      console.log('Upload completato:', response);
    } else {
      throw new Error(`Errore upload file ${file.name}`);
    }
  }

  private readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

  showShareLevelModal(folderName: string, alreadyExists: boolean, keepSettings:boolean): Promise<any> {
    const dialogRef = this.dialog.open(ShareLevelDialogComponent, {
      width: '500px',
      data: { shareLevel: 'PRV', shareLevelEdit: 'PRV', folderName: folderName, alreadyExists: alreadyExists, keepSettings: keepSettings }
    });
    return dialogRef.afterClosed().toPromise();
  }

  showShareLevelModalFile(fileName: string): Promise<any> {
    const dialogRef = this.dialog.open(ShareLevelDialogComponentFile, {
      width: '500px',
      data: { shareLevel: 'PRV', shareLevelEdit: 'PRV', fileName: fileName }
    });
    return dialogRef.afterClosed().toPromise();
  }

  showOverwriteDialog(file: any, fileContentBase64: string): void {
    console.log('Showing overwrite dialog for file:', file);
    const dialogRef = this.dialog.open(ConfirmCancelDialogComponent, {
      width: '400px',
      data: {
        title: 'Conferma Sovrascrittura',
        message: 'Un file con lo stesso nome esiste già. Vuoi sovrascriverlo?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Overwrite dialog closed with result:', result);
      if (result) {

        this.fileService.getFileUse(file.id).subscribe(
          (response: any) => {
            if (response || response.success) {
              const formData = new FormData();
              formData.append('file', file);
              formData.append('fileName', file.name);
              formData.append('fileContentBase64', fileContentBase64);
              formData.append('folderId', this.selectedFolder?.id || this.rootId);
              formData.append('shareLevel', this.selectedFolder?.shareLevel || 'PRV');
              this.fileService.uploadFile(formData, true).subscribe(
                (response: any) => {
                  console.log('Overwrite upload response:', response);
                  this.loadFiles(this.selectedFolder?.id ?? this.rootId);
                  var notification = this.translocoPipe.transform("notification.success.file.upload");
                  this.showSuccessNotification(notification);
                },
                (error) => {
                  console.error('Overwrite upload error:', error);

                  var notification = this.translocoPipe.transform("notification.error.file.upload");
                  this.showErrorNotification(notification);
                }
              );
            } else {
              var notification = this.translocoPipe.transform("notification.error.file.delete");
              this.showErrorNotification(notification);
            }
          },
          (error) => {
            console.error('Error deleting file:', error);
            var notification = this.translocoPipe.transform("notification.error.file.inUse");
            this.showErrorNotification(notification);
          }
        );


      }
    });
  }

  filterFilesByType() {
    if (this.fileCtrlFormat === 'IMAGE') {
      this.files = this.files.filter(file => this.isImageFile(file.fileName));
    } else if (this.fileCtrlFormat === 'DOC') {
      this.files = this.files.filter(file => this.isDocFile(file.fileName));
    } else if (this.fileCtrlFormat === 'VIDEO') {
      this.files = this.files.filter(file => this.isVideoFile(file.fileName));
    } else if (this.fileCtrlFormat === 'AUDIO') {
      this.files = this.files.filter(file => this.isAudioFile(file.fileName));
    } else {
    }
  }

  isExternal(isExternal: any): boolean {
    return isExternal;
  }

  isImageFile(fileName: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];
    const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return imageExtensions.includes(extension);
  }

  isDocFile(fileName: string): boolean {
    const docExtensions = ['.docm', '.docx', '.dot', '.pdf', '.xls', '.xlsx'];
    const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return docExtensions.includes(extension);
  }

  isVideoFile(fileName: string): boolean {
    const extension = fileName.split('.').pop().toLowerCase();
    return ['mp4', 'webm', 'ogg'].includes(extension);
  }


  isAudioFile(fileName: string): boolean {
    return fileName.toLowerCase().endsWith('.mp3') || fileName.toLowerCase().endsWith('.wav');
  }

  isPdfFile(fileName: string): boolean {
    return /\.pdf$/i.test(fileName);
  }

  formatFileSize(size: number): string {
    if (size < 1024) return `${size} bytes`;
    else if (size < 1048576) return `${(size / 1024).toFixed(1)} KB`;
    else return `${(size / 1048576).toFixed(1)} MB`;
  }


  formatDate(timestamp: number): string {
    const date = new Date(timestamp);
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  refresh(): void {
    this.loadFolders(this.rootId);
    this.loadFiles(this.selectedFolder?.id ?? this.rootId);
  }

  close(): void {
    console.log('Closing with selected file:', this.selectedFile);
    if (this.selectedFile) {
      this.dialogRef.close(this.selectedFile);
    } else {
      this.dialogRef.close();
    }
  }

  setFileValue(selectedFile: any) {
    console.log('Setting file:', selectedFile);
    if (!selectedFile.contentType) {
      selectedFile.contentType = this.getFileContentType(selectedFile.fileName);
    }
    this.dialogRef.close(selectedFile);
  }

  onSelectionChange(event: any) {
    this.selectedFolder = event.dataItem;
    console.log('Selected folder:', this.selectedFolder);

    this.selectedFile = null;
    this.selectedFiles = [];
    localStorage.setItem('lastFolderPath', JSON.stringify(this.selectedFolder.fullPath));

    this.loadFiles(this.selectedFolder?.id ?? this.rootId)
  }

  // Icone basate sull'estensione del file
  getIcon(fileName: string): string {
    const ext = fileName.split('.').pop().toLowerCase();
    switch (ext) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'bmp':
      case 'gif':
      case 'svg':
        return 'image';
      case 'doc':
      case 'docx':
      case 'dot':
      case 'dotx':
      case 'pdf':
      case 'xls':
      case 'xlsx':
      case 'ppt':
      case 'pptx':
        return 'description';
      case 'mp4':
      case 'avi':
      case 'wmv':
        return 'videocam';
      case 'mp3':
      case 'wav':
      case 'flac':
        return 'audiotrack';
      default:
        return 'insert_drive_file';
    }
  }

  /*onContextMenu(event: MouseEvent, folder: any): void {
    event.preventDefault();
    //
    if (folder == null){
      this.contextMenuVisible = false;
      this.contextMenuPosition = { x: 0 + 'px', y: 0 + 'px' };
      return;
    }

    // Controlla se la cartella è la root principale
    if (folder.id === this.rootId) {
      this.contextMenuVisible = false; // Assicurati che il menu contestuale sia nascosto
      var notification = this.translocoPipe.transform("notification.error.folder.editRoot");
      this.showErrorNotification(notification);

      return; // Non mostrare il menu contestuale per la root principale
    }

    this.selectedFolder = folder;
    this.contextMenuVisible = true;
    this.contextMenuPosition = { x: event.clientX + 'px', y: event.clientY + 'px' };
  }*/

  /*onContextMenuSelect(event: any): void {
    const action = event.item?.data.toLowerCase();
    if (!action) {
      var notification = this.translocoPipe.transform("notification.error.folder.editSystem");
      console.error('Invalid action:', event);
      return;
    }

    // Verifica se l'utente è l'owner
    const isOwner = this.isFolderOwner(this.selectedFolder);

    // Verifica se la cartella selezionata è di sistema
    const isSystemFolder = this.isFolderSystem(this.selectedFolder);

    if (isSystemFolder) {
      console.error('Cannot modify or delete a system folder.');
      var notification = this.translocoPipe.transform("notification.error.folder.editSystem");
      this.showErrorNotification(notification);
      return;
    }

    switch (action) {
      case 'rinomina':
        if (isOwner) {
          this.renameFolder();
        } else {
          console.error('User is not the owner. Cannot rename.');
          var notification = this.translocoPipe.transform("notification.error.folder.editNotOwner");
          this.showErrorNotification(notification);
        }
        break;
      case 'elimina':
        if (isOwner) {
          this.openDeleteFolderDialog();
        } else {
          console.error('User is not the owner. Cannot delete.');
          var notification = this.translocoPipe.transform("notification.error.folder.deleteNotOwner");
          this.showErrorNotification(notification);
        }
        break;
      default:
        console.error('Unknown action:', action);
        var notification = this.translocoPipe.transform("notification.error.folder.unknownAction");
        this.showWarnNotification(notification);
    }
  }*/


  renameFile(file: any): void {
    const dialogRef = this.dialog.open(NewFolderDialogComponent, {
      width: '400px',
      data: { fileName: file.fileName, errorMessage: '', action: 'rename' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const updatedFile = {
          ...file,
          fileName: result,
          id: file.id
        };
        this.fileService.updateFileName(updatedFile.id, updatedFile.fileName, updatedFile.folderId).subscribe(
          (response: any) => {
            console.log('Rename file response:', response); // Log the response for debugging
            if (response.success) {
              this.loadFiles(this.selectedFolder?.id ?? this.rootId);
            } else {
              var notification = this.translocoPipe.transform("notification.error.file.existingName");
              this.showErrorNotification(notification);
            }
          },
          (error) => {
            console.error('Rename file error:', error); // Log the error for debugging
            var notification = this.translocoPipe.transform("notification.error.file.existingName");
            this.showErrorNotification(notification);
          }
        );
      }
    });
  }

  deleteFolder(folder:any): void {

    const dialogRef = this.dialog.open(ConfirmCancelDialogComponent, {
      width: '400px',
      data: {
        title: this.translocoPipe.transform('modal.folder.title'),//'Conferma Eliminazione',
        message: this.translocoPipe.transform('modal.folder.text'),//'Sei sicuro di voler eliminare la cartella',
        entityName: folder?.folderName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fileService.deleteFolder(folder.id).subscribe(
          response => {
            if (response.success) {
              console.log('Folder deleted', response);
              this.loadFolders(this.rootId);
              this.selectedFolder = null;
            } else {
              var notification = this.translocoPipe.transform("notification.error.folder.delete");
              this.showErrorNotification(notification);
  
            }
          },
          error => {
            console.error('Error deleting folder:', error);
            var notification = this.translocoPipe.transform("notification.error.folder.delete");
            this.showErrorNotification(notification);
          }
        );
      }
    });

  }

  openPropertiesDialog(type: 'folder' | 'file') {
    if (type === 'folder' && this.selectedFolder && !this.isRootSelected()) {
      const dialogRef = this.dialog.open(ShareLevelPropertiesDialogComponent, {
        width: '400px',
        data: {
          isFolder: true,
          itemId: this.selectedFolder.id,
          itemName: this.selectedFolder.folderName,
          shareLevel: this.selectedFolder.shareLevel,
          shareLevelEdit: this.selectedFolder.shareLevelEdit,
          isOwner: this.isFolderOwner(this.selectedFolder),
          isSystem: this.isFolderSystem(this.selectedFolder)
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Aggiorna l'interfaccia
          this.selectedFolder.shareLevel = result.shareLevel;
          this.selectedFolder.shareLevelEdit = result.shareLevelEdit;
        }
      });
    }
    else if (type === 'file' && this.selectedFile) {
      const dialogRef = this.dialog.open(ShareLevelPropertiesDialogComponent, {
        width: '400px',
        data: {
          isFolder: false,
          itemId: this.selectedFile.id,
          itemName: this.selectedFile.fileName,
          shareLevel: this.selectedFile.shareLevel,
          shareLevelEdit: this.selectedFile.shareLevelEdit,
          isOwner: this.isFileOwner(this.selectedFile),
          isSystem: this.isFileSystem(this.selectedFile),
          isExternal: this.selectedFile.isExternal
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Aggiorna l'interfaccia
          this.selectedFile.shareLevel = result.shareLevel;
          this.selectedFile.shareLevelEdit = result.shareLevelEdit;
        }
      });
    }
  }
  

  // Aggiungi il metodo openPreviewDialog alla classe FileManagerComponent
  openPreviewDialog(file: any): void {
    if (this.isImageFile(file.fileName) || this.isPdfFile(file.fileName)) {
      this.fileService.readFileAsBase64String(file.id).subscribe((fileRes: any) => {
        const fileUrl = `data:${fileRes.contentType};base64,${fileRes.fileContentBase64}`;
        const dialogRef = this.dialog.open(FilePreviewDialogComponent, {
          width: '80%',
          height: '80%',
          data: {
            file: {
              id: fileRes.id,
              fileName: file.fileName,
              dataUrl: fileUrl || fileRes.dataUrl,
              contentType: fileRes.contentType
            }
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
        });
      }, error => {
        console.error('Error loading file preview:', error);
      });
    }
  }

  onNodeClick(event: any): void {
    this.selectedFolder = event.item.dataItem;
    if (!this.isRootSelected()) {
      this.loadFiles(this.selectedFolder.id);
    }
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.contextMenuVisible = false;
  }
}

export class UploadCancelledError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UploadCancelledError';
  }
}



